// extracted by mini-css-extract-plugin
export default {"mainContent":"styles_mainContent__X3jEA","formConteiner":"styles_formConteiner__Ce9-O","formWrapper":"styles_formWrapper__TbATU","languageSwitcher":"styles_languageSwitcher__HqO8j"};